import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseNestService from "../../services/caseNestService";

const useCaseSummary = (caseId, environment) =>
  useQuery([queryKeys.caseSummary, caseId, environment], () => caseNestService.fetchCaseSummary(caseId, environment), {
    enabled: !!caseId,
  });

export default useCaseSummary;
